//
// Copyright (c) 2011-2017 by Curalate, Inc.
//

(function() {
  angular.module('curalate').component('clientGroupDisplay', {
    template: require('@legacy-components/settings-menu/client-group-display.html'),
    bindings: {
      group: '<?',
    },
    controller: [
      '$element',
      'SessionVarsService',
      function(
                $element,
                SessionVarsService,
            ) {
        this.$onInit = function() {
          $element[0].classList.add('cu-w-100');
          this.brandName = SessionVarsService.getClientName();
          if (!this.group) {
            this.group = SessionVarsService.getGroup();
          }
          this.groups = SessionVarsService.getGroupsAndBrands();
        };
      },
    ],
  });
})();
